import { getContext } from '@fiverr-private/fiverr_context';
import { sendClickEventToBQ } from '../../BigQuery';
import { sendClickEventToMixPanel } from '../../Mixpanel';
import { MIXPANEL_EVENT_NAMES } from '../../constants';

const getMixpanelPayload = ({ source, sellerUsername, sellerId }) => {
    const { userId, organizationId } = getContext();
    return {
        'User Id': userId?.toString(),
        'Is Guest': !userId,
        'Organization Id': organizationId,
        'Seller Username': sellerUsername,
        'Seller Id': sellerId,
        'Page Name': source,
    };
};

export const clickOnGigServiceCardEvent = ({ gigId, source, sellerUsername, sellerId, componentName, domain }) => {
    sendClickEventToMixPanel({
        eventName: MIXPANEL_EVENT_NAMES.CLICKED_ON_GIG_SERVICE_CARD,
        'Gig Id': gigId,
        ...getMixpanelPayload({ source, sellerUsername, sellerId }),
    });

    sendClickEventToBQ({
        type: 'clicked_on_gig_card',
        pageName: source,
        seller: { id: sellerId, username: sellerUsername },
        featureName: 'click_on_gig',
        gigId,
        componentName,
        domain,
    });
};

export const clickOnGigCustomOrderEvent = ({ source, sellerUsername, sellerId }) => {
    sendClickEventToBQ({
        type: `${source}.get_quote`,
        pageName: source,
        seller: { id: sellerId, username: sellerUsername },
        featureName: 'get_a_quote',
    });

    sendClickEventToMixPanel({
        eventName: MIXPANEL_EVENT_NAMES.CLICKED_ON_GIG_REQUEST_QUOTE,
        ...getMixpanelPayload({ source, sellerUsername, sellerId }),
    });
};
